import AllConnect from '@/components/HomebuyerOffers/AllConnect.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/offers/AllConnect',
  name: RouteNames.AllConnect,
  component: AllConnect,
};

export default route;
